<template>
    <card title="Reset Patient App Password">
        <div style="margin-bottom: 15px; margin-left: 20px">
            <b-row>
                <p>
                    An auto generated temporary password will be sent to this patient's email and/or
                    SMS.
                </p>

                <p>
                    Once the temporary password is used it will prompt the patient to create a
                    permanent password on the Patient App.
                </p>

                <p>Are you sure you want to reset the patient app password?</p>
                <NewClearSaveButtons :titles="_buttonTitles" :disable-save="!isFormValid"
                    @cancel-clicked="$emit('close')" @save-clicked="updatePassword" />
            </b-row>
        </div>
    </card>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { Patient } from "@/models/Patient";
import axios from "axios";
import { NotificationOptions } from "@/util/NotificationOptionsPresets";
import NewClearSaveButtons, { NewClearSaveTitles } from "@/components/NewClearSaveButtons.vue";
import NotificationTypes = NotificationOptions.NotificationTypes;

@Component({
    name: "ResetPatientAppPasswordComponent",
    components: { NewClearSaveButtons },
})
export default class ResetPatientAppPasswordComponent extends Vue {
    @Prop() private patient!: Patient;

    private isSubmitting = false;

    updatePassword() {
        if (this.isSubmitting) return;
        this.isSubmitting = true;
        axios
            .post<string>(`Patient/reset-patientApp-password`, this.patient)
            .then((res) => {
                if (res.data.length) {
                    this.$notification(NotificationOptions.warning(res.data));
                } else {
                    this.$notification(NotificationOptions.successSaveNotificationPreset("Password Reset"));
                }
                this.$emit("close");
            })
            .catch((err) => {
                console.warn(err);
                this.$notification(NotificationOptions.error(err));
            })
            .finally(() => {
                this.isSubmitting = false;
            });
    }

    private get _buttonTitles() {
        let res: NewClearSaveTitles;
        res = {
            save: "Reset Password",
            clear: "",
            new: "",
            cancel: "Cancel",
        };
        return res;
    }

    get isFormValid() {
        return !this.isSubmitting;
    }
}
</script>
